import { QueryClient } from "@tanstack/react-query";

const NO_REFETCH_STATUS_CODES = [401, 403, 404, 409, 422, 500];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        // Don't retry on 404 errors
        if (
          error instanceof Response &&
          NO_REFETCH_STATUS_CODES.includes(error.status)
        ) {
          return false;
        }
        // Retry on all other errors
        return failureCount < 3;
      },
    },
  },
});
